import styled from "styled-components";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Person2Icon from "@mui/icons-material/Person2";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarIcon from "@mui/icons-material/CalendarToday";
import BusinessIcon from "@mui/icons-material/Business";
import ConstructionIcon from "@mui/icons-material/Construction";
import EngineeringIcon from "@mui/icons-material/Engineering";

export type ProfileType = {
  name: string;
  bio: string;
  status: string;
  user_id: string;
  avatar: string;
};

// export interface UserType {
//   user_id: string;
//   username: string;
// }

export type WorkPlan = {
  Objekt: string;
  PL: string;
  Monteure: string[];
  Abfahrt: string;
  Bemerkung: string;
};

export type AbwesenheitType = {
  Person: string;
  Zeit: string;
};

export type ArbeitsplanType = {
  mitarbeiter: string;
  datum: string;
  zeitvon: string;
  zeitbis: string;
  terminart: string;
  bemerkung: string;
  fahrzeug: string;
  gerate: string;
  ressourcen: string;
  gesamttermindatumvon: string;
  gesamtterminvon: string;
  gesamttermindatumbis: string;
  gesamtterminbis: string;
  vorgang: string;
  betreff: string;
  bauleiter: string;
  tel_bauleiter: string;
  adresse: string;
  kunde_name: string;
  kunde_strasse: string;
  kunde_plz: string;
  kunde_ort: string;
  objekt: string;
  objekt_name: string;
  objekt_strasse: string;
  objekt_plz: string;
  objekt_ort: string;
  tel_adresse: string;
  mobil_adresse: string;
  tel_objekt: string;
  mobil_objekt: string;
  modifiedon: string;
};

export type UserType = {
  id: string;
  username: string;
  bemerkung: string;
  mitarbeiternummer: number;
  kurzel: string;
  adresse: string;
  nameAdresse: string;
  geburtsdatum: string;
  austrittsdatum: string;
  first_name: string;
  last_name: string;
  is_staff: boolean;
  is_superuser: boolean;
  checked: Date;
  late: Date;
  late_minutes: number;
  sick: Date;
  street: string;
  mobilephone: string;
  plz: string;
  wohnort: string;
};

export type selectedDayType = { days: moment.Moment[]; abbr: string };

export const WorkPlanContainer = styled.div`
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  margin-right: 10px;
  margin-left: 10px;
`;

export const Title = styled.h2`
  font-size: 1.5em;
  margin-bottom: 10px;
`;

export const Info = styled.div`
  margin-bottom: 15px;
`;

export const InfoItem = styled.p`
  margin: 0;
  font-weight: normal;
`;

export const MonteureList = styled.ul`
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
`;

export const MonteureItem = styled.li`
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 5px 5px;
  background-color: #f2f2f2;
  border-radius: 1px;
  font-size: 1em;
`;

export const AbfahrtIcon = styled(AccessTimeIcon)`
  margin-right: 5px;
`;

export const KalenderIcon = styled(CalendarIcon)`
  margin-right: 5px;
`;

export const HelpIcon = styled(HelpOutlineIcon)`
  margin-right: 5px;
`;

export const PersonIcon = styled(Person2Icon)`
  margin-right: 5px;
`;
export const AdresseIcon = styled(BusinessIcon)`
  margin-right: 5px;
`;
export const ObjektIcon = styled(ConstructionIcon)`
  margin-right: 5px;
`;
export const MonteurIcon = styled(EngineeringIcon)`
  margin-left: 3px;
  margin-right: 5px;
`;
export const TelefonIcon = styled(PhoneIcon)`
  margin-right: 5px;
`;

export interface ArbeitsplanPageProps {
  mbNummer?: number;
}

export interface WorkPlanProps {
  workPlan: ArbeitsplanType;
  users: UserType[];
}

export interface WorkPlanListProps {
  workPlanList: ArbeitsplanType[];
  userList: UserType[];
}

export enum Terminarten {
  "Kundendienst (FEST)" = "1",
  "Kundendienst (verschiebbar)" = "2",
  "Feiertag" = "3",
  "Büro" = "4",
  "Bau (Rheine)" = "10",
  "Bau (tägl. Fahrten)" = "11",
  "Bau (Montage)" = "12",
  "Termin außer Haus" = "13",
  "PV-Abteilung" = "14",
  "Werkstatt" = "20",
  "Laden" = "21",
  "Schule" = "30",
  "Weiterbildung" = "31",
  "überbetriebliche Unterweisung" = "32",
  "Prüfung" = "35",
  "Geburtstag" = "40",
  "Urlaub" = "41",
  "Krank" = "42",
  "Freizeitausgleich" = "43",
  "Freizeitausgleich (angefragt)" = "44",
  "Baustellentermin" = "50",
  "Wartung" = "51",
  "Störung" = "52",
  "Baubesprechung" = "60",
  "Besprechungstermin" = "61",
  "Vergabetermin" = "62",
  "Teamsbesprechung ( VIKO )" = "63",
  "Urlaubsanfrage" = "64",
  "Praktikant (Anfrage)" = "65",
  "Praktikant (Bestätigt)" = "66",
  "Arbeitsunfall" = "67",
  "Ankündigung" = "68",
  "Notdienst" = "69",
  "Dauernachricht" = "70",
}
export type AbwesendMitarbeiter = {
  name: string;
  dateRange: string | null;
};

export type PollType = {
  question: string;
  options: PollOptionType[];
  is_anonymous: boolean;
  thread_id: string;
  id: string;
};

export type PollOptionType = {
  id: string;
  option_text: string;
  votes: string;
};
export type ThreadType = {
  id?: number;
  subject: string;
  content: string;
  created?: Date;
  updated?: Date;
  creator_id?: number;
  topic_id?: number;
  topic: TopicType;
  replyCount?: number;
  creator: string | UserType;
};
export type ReactionType = {
  id: number;
  emoji: string;
  thread_id: number;
  user_id: number;
};
export type PostType = {
  id: number;
  content: string;
  created: Date;
  updated: Date;
  creator_id: number;
  thread_id: number;
  creator: string;
  poll: PollType;
};
export type TopicType = {
  id: number;
  label: string;
  creator: string;
  creator_id: number;
};
export type FileType = {
  file_name: string;
  file_url: Date;
};
